import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isLight ? "Uključi noćnu temu" : "Uključi dnevnu temu"}
      data-testid="theme-toggle"
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-full border border-[#FFD60A]/40 bg-[#FFD60A]/10 hover:bg-[#FFD60A]/20 transition-colors ${className}`}
    >
      {isLight ? <Moon size={16} className="text-[#8a6b00]" /> : <Sun size={16} className="text-[#FFD60A]" />}
      <span className={`text-[11px] font-bold uppercase tracking-widest ${isLight ? "text-[#8a6b00]" : "text-[#FFD60A]"}`}>
        {isLight ? "Noć" : "Dan"}
      </span>
    </button>
  );
}
